import { CommonCloudStudioModule, SidebarContainerModule } from 'common-cloudstudio';
import { ToasterModule } from 'angular2-toaster';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@NgModule({
	imports: [
		RouterModule, 
		FormsModule, 
		CommonModule,
		ToasterModule,
		SidebarContainerModule,
		CommonCloudStudioModule,
		CollapseModule
	],
	declarations: [SidebarComponent],
	exports: [SidebarComponent]
})

export class SidebarModule { }
